<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre1">Das patentierte Krokodil</h3>
<p class="calibre2">Es war eine Wüste, und in der Wüste war ein Fluß, und in dem
Fluß war ein Krokodil. Es tut mir leid, es zu sagen, aber Krokodile
sind nicht beliebt. Nein. Das kommt nicht etwa daher, weil ihre
Toilette meist schlammig und salopp ist oder weil sie unleugbar
einen etwas unsympathischen Zug um den Mund haben; denn das sind
schließlich Äußerlichkeiten. Die Unbeliebtheit kommt vom Appetit.
Das ist in der ganzen Welt so: je größer der Appetit, um so kleiner
die Beliebtheit. Liebe und Freundschaft gedeihen nur unter
Ausschluß des Appetits, und man versteigt sich sogar so weit, die
harmloseste Konversation nur einzugehen unter der engherzigen
Bedingung, daß man nicht gefressen oder auch nur angeknabbert wird.
Es ist gewiß einseitig, aber auch begreiflich; denn niemand will,
kaum daß ein paar verbindliche Worte gewechselt sind, gleich ohne
Hände oder Beine dasitzen, die er doch andenweit benötigt und die
ihm schließlich auch gehören. Und so ist man bei jedem, den man
verschlucken will, unbeliebt. Da nun das Krokodil auf alles Appetit
hat und alles verschlucken will, so ist es auch bei allen
unbeliebt. Es schluckt Missionare, Frösche, Neger, Affen und selbst
die eigenen Familienangehörigen – alles aus Appetit. Es bekommt ihm
auch alles – Gott sei Dank –, und es verdaut auch alles, sogar
seine Verwandten. Das Krokodil lag also in dem Fluß, der in der
Wüste war, hatte Appetit und war böse. Böse war es nicht, weil es
Appetit hatte, sondern weil nichts da war für den Appetit, und da
ist jeder böse, nicht nur ein Krokodil, sondern auch die zarteste
Dame. »Wie schön wäre jetzt ein Weißer!« sagte das Krokodil und
blinzelte in die Morgensonne. »Weiße sind zum Frühstück am besten,
Neger sind besser zum Mittagessen, sie sind öliger und halten
länger vor. Es ist ein Unterschied wie zwischen Huhn und Ente.
Pikant sind Weinreisende, sie haben Wildgeschmack durch den
Alkoholgenuß und sind meist gut im Stande.«</p>
<p class="calibre2">Das Krokodil lächelte wehmütig, wodurch sich der unangenehme Zug
um den Mund noch verschärfte, so leid es mir tut, das zu sagen.
»Nicht mal einheimische Küche ist zu haben«, fuhr das Krokodil fort
und schluckte heißhungrig, »ich wäre schon mit Hausmannskost
zufrieden, mit einem Neffen oder einer Nichte. Aber einen Teil hab'
ich gegessen, die anderen sind flußabwärts geschwommen, man hat gar
kein verwandtschaftliches Gefühl mehr heutzutage. Was nützt da der
Appetit?!« Und das Krokodil bettete seinen hungrigen Magen tiefer
in den nassen Schlamm, machte die Augen resigniert zu und gähnte.
Dabei hielt es nicht mal die Vordertatze vor den Mund; denn der
Mund ist sowieso zu groß, und dann gibt das Krokodil überhaupt
nicht viel auf Manieren. Ich werde dösen, dachte es – und es döste.
Oben auf dem Dattelbaum botanisierte emsig und leise gurrend ein
kleiner Makak. Es war ein sehr fröhliches Äffchen, und es freute
sich permanent darüber, daß es ein Äffchen war und daß es überhaupt
da war. Dazwischen turnte es ein wenig nach der Methode »Mein
System« oder »Wie bekomme ich den schönsten Schwanz, die längsten
Arme und die kürzesten Beine?«. Dann setzte es sich auf einen Ast
und suchte mit größter Aufmerksamkeit nach lästigen Ausländern in
seinem Fell und exmittierte sie ohne Unterschied, Männer und Frauen
und selbst zarte Kinder. Es war eine mühselige, aber ertragreiche
und dankbare Arbeit.</p>
<p class="calibre2">»An drei Stellen zugleich kann ich mich kratzen«, sagte der
kleine Makak und grinste selbstzufrieden, »mit dem Schwanz und dem
einen Bein halte ich mich, was übrig ist, das kratzt. Wie weise ist
doch die Natur!« Der kleine Makak war eben ein sonniges und
bescheidenes Gemüt. Mitten in dieser Prüfung seiner Garderobe wurde
er jedoch durch das etwas heisere Organ des Krokodils gestört. Das
Krokodil hatte nach oben gesehen und das Äffchen bemerkt. »Pst,
Sie«, rief es, »kommen Sie runter, ich will Sie fressen.« Es sagte
»fressen«, denn das Krokodil hat keine feine Ausdrucksweise. Der
kleine Makak erschrak furchtbar. »Nein; keinesfalls!« sagte er
weinerlich, und sein Fell sträubte sich vor Angst, so daß die
lästigen Ausländer ganz verstört umherliefen. »Sie wollen also
nicht«, fauchte das Krokodil hämisch und pustete bösartig durch die
Nasenlöcher. »Gut, ich werde warten, bis der Appetit Sie vom Baum
treibt, wenn nichts mehr da ist. Alles im Leben ist Appetit. Ich
weiß das.«</p>
<p class="calibre2">Der kleine Makak sagte gar nichts mehr, er nahm ein Dattelblatt
und schluchzte fassungslos hinein. Wo war nun die Weisheit der
Natur, was nützten einem nun die langen Arme und die kurzen Beine,
die man durch »Mein System« erzielte, wenn sie verschluckt werden
sollten? »Arroganter Kerl«, knurrte das Krokodil und räusperte sich
gehässig, »ziert sich, als wäre er ein besonderer Leckerbissen,
dabei ist Affenfleisch ganz kommun.« Der kleine Makak war aber gar
nicht arrogant, er hatte bloß schreckliche Angst, weil er gefressen
werden sollte, und er dachte an Papa und Mama und an des
Makaknachbars älteste Tochter, von deren lächelndem Mäulchen er den
ersten Kuß bekommen, weil er ihr galant und ritterlich das zarte
Fell abgesucht hatte. Und bei solchen Gedanken ist das ganz gleich,
ob es ein großer Mensch ist oder eine kleine, zitternde Affenseele
– und bei vielem anderen übrigens auch. Aber es gibt etwas auf der
Welt, das sich dazwischen armer, geängstigter Geschöpfe erbarmt,
und es erbarmte sich auch des kleinen Äffchens. Grad als der Makak
zum zweiten Dattelblatt griff und hineinheulte, war ihm, als
umschlänge ihn ein Affenschwanz, und eine Stimme flüsterte ihm
einen Gedanken zu – es konnte Mama oder Papa sein oder des Nachbars
Älteste. Der Gedanke war so schön, daß der kleine Makak sofort
aufhörte zu heulen, sein Fell legte sich wieder, und sein Frätzchen
nahm den Ausdruck unsagbarer Heiterkeit an, der Heiterkeit, die so
besonders hübsch ist, wenn sie ein häßliches Gesicht verklärt.</p>
<p class="calibre2">»Pst, Sie«, äffte der kleine Makak das Krokodil nach und warf
ihm Dattelkerne auf den Kopf. »Sind Sie denn auch patentiert?«</p>
<p class="calibre2">Wie viele sind so! Kaum geht's ihnen gut, so schmeißen sie mit
Dattelkernen. Das ist menschlich, und die Affen haben ja so etwas
Menschliches.</p>
<p class="calibre2">»Wieso patentiert?« fragte das Krokodil mißtrauisch, »ich will
Sie fressen, und das werde ich auch tun.«</p>
<p class="calibre2">Das Äffchen kreuzte die langen Arme über der Brust und sah
überlegen auf das Krokodil herab. »Alle anständigen Leute in der
Wüste werden jetzt patentiert«, sagte es, »sonst ist man nicht
fair. Aber man muß was haben, was andere nicht haben.«</p>
<p class="calibre2">Dich will ich bald haben, dachte das Krokodil ärgerlich; aber
die Sache ging ihm im Kopf herum, denn es wollte gern fair sein. Da
ein Krokodilgehirn nicht groß ist – je größer das Maul, um so
kleiner das Gehirn –, war seine Denkkraft bald erschöpft. »Wo
kann man denn patentiert werden?« fragte es. »Beim
Wüstenpatentkomitee. Das ist ein Büro.« Das Krokodil besann sich.
»Wie komme ich da am besten hin?« erkundigte es sich,
»vorausgesetzt, daß es nicht weit ist und daß Sie hier warten.
Darauf muß ich mich verlassen können.«</p>
<p class="calibre2">»Sicher«, sagte das Äffchen und rieb sich die Hände vor
Vergnügen, »das Büro ist, wie alle Büros, in der Wüste. Guten
Erfolg, hoffentlich reüssieren Sie!«</p>
<p class="calibre2">Das Krokodil krabbelte ans Ufer und trottete langsam in die
Wüste hinein. Nach einer Weile kam es an eine Bretterbude, da
dachte das Krokodil: Aha. Wie viele haben schon »Aha« gedacht, aber
es war nichts dahinter. Diesmal aber war es doch richtig, denn auf
der Bude stand in großen Lettern: Wüstenpatentkomitee GmbH
(Gesellschaft mit besondrer Hinterpfote). Eben verließ das
Rhinozeros mit freundlichem Kopfnicken das Lokal, und das Krokodil
trat ein und stand vor dem Komitee.</p>
<p class="calibre2">Das Komitee bestand aus dem Kamel, dem Marabu und dem Panther.
Das Kamel hatte die Akten zu führen und sonstige Schreiberdienste
zu verrichten, es ließ mit subalterner Miene die Unterlippe hängen
und trug das allgemeine Wüstenehrenzeichen um den Hals, eine kleine
Tretmühle in den Landesfarben. Der Marabu hatte keine Haare auf dem
Kopf und war juristischer Beirat, und der Panther als Vertreter der
Behörde saß an einem Tisch und manikürte seine Pfoten. Als das
Krokodil sah, daß das ganze Komitee eßbar war, klappte es vor
Appetit mit den Kinnbacken. »Hören Sie doch auf zu klappen!« schrie
der Panther gereizt, »macht einen ja nervös!«</p>
<p class="calibre2">Das Krokodil ärgerte sich, aber es wollte gern ein Patent haben,
und so legte es bescheiden und leise die obere Kinnlade auf die
untere.</p>
<p class="calibre2">»Was wünschen Sie?« fragte das Kamel und schob die subalterne
Unterlippe nach oben.</p>
<p class="calibre2">»Ich will patentiert werden.«</p>
<p class="calibre2">»Und woraufhin?«</p>
<p class="calibre2">»Das ist mir ganz egal. Auf meinen Appetit.«</p>
<p class="calibre2">»Lachhaft«, murmelte der Panther,«haben ja alle.«</p>
<p class="calibre2">»Dann auf mein großes Maul«, sagte das Krokodil eingeschüchtert
und sperrte den Rachen empfehlend auf. »Ihr pp. Maul ist recht
groß, wie wir es hier in loco sehen«, meinte der Marabu als
juristischer Beirat, »aber damit stehen Sie nicht allein da. Die
meisten Menschen haben ein viel größeres.«</p>
<p class="calibre2">Das Krokodil weinte zwei von den bekannten Krokodilstränen und
glotzte ratlos und dösig auf das eßbare Komitee. Schließlich wurde
es aber böse und schlug den Schuppenschwanz erregt hin und her.
»Ich will aber patentiert werden!« schnappte es asthmatisch vor
Ärger.</p>
<p class="calibre2">»Ruhe! Sonst werden Sie rausgeschmissen!« brüllte der Panther
und schlug mit der Pfote auf den Tisch.</p>
<p class="calibre2">»Jawohl, Ruhe!« blökte das Kamel und ließ die subalterne
Unterlippe devot hängen, indem es diensteifrig nach dem Panther
schielte.</p>
<p class="calibre2">»Wenn ich Ihnen einen Rat geben darf«, kakelte der Marabu
höflich und beschwichtigend, »so würde ich Ihr Gebiß patentieren
lassen. Soweit ich es übersehen konnte, als Sie Ihr wertes Maul
öffneten, ist es von achtbaren Dimensionen und jedenfalls einzig in
seiner Art. Es ließe sich als Fleischhackmaschine
registrieren.«</p>
<p class="calibre2">»Also dalli«, sagte der Panther, zum Kamel gewandt, und strich
sich die Schnauze, »lesen Sie das Register vor!« Das Kamel las
eintönig, mit blökender Stimme, da es der Meinung war, es käme
einem Unterbeamten nicht zu, ein Wort eigenmächtig besonders zu
betonen. »Patent Nr. 1. Der Brillenschlange für eine
Brillenzeichnung auf dem Kopfe. Abteilung optische Geräte. Patent
Nr. 2. Dem Känguruh für eine Beuteltasche auf dem Magen. Abteilung
Galanteriewaren. Patent Nr.3. Dem Rhinozeros für ein Horn auf der
Nase. Abteilung Bijouterie.« »Sie können nun zwischen einem
englischen und einem deutschen Patent wählen«, wandte sich der
Marabu an das Krokodil, »auf dem englischen steht darauf 'made in
Germany' und auf dem deutschen ›façon de Paris‹.« »Welches ist denn
besser?« fragte das Krokodil mißtrauisch. »Das ist lediglich
Geschmackssache«, sagte der Marabu, »das Känguruh zum Beispiel
wählte das englische Patent mit Rücksicht auf die politischen und
gesellschaftlichen Verhältnisse Australiens, während das
Rhinozeros, das nur auf Schick etwas gibt, sich ohne Besinnen für
façon de Paris entschieden hat.«</p>
<p class="calibre2">»Ich will aber beide haben«, sagte das Krokodil.</p>
<p class="calibre2">»Das geht nicht«, meinte der Marabu und zuckte bedauernd die
Flügel, »aber ich würde Ihnen, da es sich um eine
Fleischhackmaschine handelt, zum englischen Patent raten ...« »Also
Schluß!« brüllte der Panther, »schreiben Sie: Patent Nr. 4. Dem
Krokodil für eine Fleischhackmaschine – im Maul – äh – Abteilung
Küchengeräte. Guten Morgen!« Mit diesen Worten stand der Panther
auf, nahm den Schwanz vorschriftsmäßig über die Pfoten und verließ
schnurrend das Lokal; die Bürostunden waren zu Ende.</p>
<p class="calibre2">Das Kamel fertigte das Diplom aus, und der Marabu übergab es dem
Krokodil mit einigen ermahnenden Worten. »Seien Sie recht
vorsichtig«, sagte er, »Diplome sind etwas rein Dekoratives, sie
sind auf sogenanntem autosuggestivem Wege aus dem überaus zähen und
gänzlich unverdaulichen Stoff der Tradition hergestellt – ein
übrigens internationales Verfahren –, also verschlucken Sie es
ja nicht! Ich empfehle mich Ihnen.« Und der juristische Beirat
frühstückte einen langen Wurm, den ihm seine Frau in
Butterbrotpapier eingewickelt hatte. Marabus lebten in der Nähe
einer europäischen Niederlassung und waren schwer kultiviert. Daher
das Butterbrotpapier und die juristischen Kenntnisse.</p>
<p class="calibre2">Als das Krokodil den juristischen Beirat frühstücken sah, wurde
ihm ganz schwach. Es nahm behutsam sein Diplom zwischen die Zähne
und trottete eiligst ab, dem Flußufer zu, um den kleinen Makak zu
fressen. Aber das Äffchen war nicht mehr da.</p>
<p class="calibre2">Wie unzuverlässig doch heutzutage die Leute sind! dachte das
Krokodil, kein Wunder, daß man das Alte und Gute patentiert. Und es
blies sich ganz dick auf vor Stolz und kroch mitten in den Schlamm
hinein.</p>
<p class="calibre2">So lag es Stunden. Indes war es Abend geworden, und es sammelte
sich viel Publikum im Fluß und an den Ufern, um Abendbrot
einzufangen.</p>
<p class="calibre2">»Warum speisen Sie nichts, Herr Kollege?« fragte ein kleiner
Alligator das Krokodil im Vorbeischwimmen. Er sah satt und
zufrieden aus und schluckte mit jovialer Miene an den Resten eines
Angehörigen.</p>
<p class="calibre2">Das Krokodil konnte schwer sprechen. »Ich bin patentiert«,
lispelte es hochmütig, »ich kann nichts essen, ich habe mein Diplom
im Maul. Dafür bin ich jetzt fair.« »Ich für mein Teil bin lieber
satt«, meinte der kleine Alligator, »aber Sie sehen ja aus, als
hätten Sie seit heute früh nichts mehr zu sich genommen. Das
gesunde Grün Ihrer Gesichtsfarbe ist förmlich grau geworden. Legen
Sie doch Ihr Diplom ans Ufer und speisen Sie zu Abend!« Das
Krokodil kämpfte innerlich – der Appetit war furchtbar. »Nein«,
lispelte es schließlich mühsam, »am Ufer stehlen es mir die
Affen.«</p>
<p class="calibre2">»Dann spucken Sie's einfach aus!« sagte der kleine Alligator
frech, »wozu brauchen Sie denn ein Diplom? Wenn man ein Diplom nur
immer im Maul haben kann, soll man lieber darauf verzichten, sonst
kann man nichts mehr fressen und wird zum Schluß selbst gefressen
und noch dazu ausgelacht.« Das ist eine große Lebensweisheit, aber
sie bezieht sich natürlich nur auf Krokodile.</p>
<p class="calibre2">Das Krokodil blieb unbeweglich. Es behielt sein Diplom im Maul
und glotzte den Vetter böse und hungrig an.</p>
<p class="calibre2">»Wenn Sie denn schon Ihr Diplom im Maul behalten«, fuhr der
Alligator fort, »so gestatten Sie vielleicht, daß ich Ihre
Hintertatze zum Nachtisch esse.«</p>
<p class="calibre2">Das Krokodil drehte sich vor Angst und Wut um sich selbst herum,
und in dieser Angst und Wut verschluckte es sein Diplom. Da wurde
ihm sehr übel, so übel, wie ihm noch nie gewesen war – und in
tiefer Ohnmacht schwamm es flußabwärts, wobei es vom Alligator und
anderen teilnehmenden Verwandten aufgegessen wurde. Damit endet
diese traurige Geschichte.</p>
<p class="calibre2">Nur eine Familienanzeige habe ich noch hinzuzufügen: Der kleine
Makak hatte sich inzwischen mit des Nachbars Ältester verlobt. Sie
waren ein glückliches Brautpaar und hatten gleich am Tage darauf
eine Garden-Party im Kreise der Angehörigen unternommen, natürlich
begleitet von einer Ehrenäffin, denn die Affen haben etwas sehr
Menschliches, wie jeder weiß. Dabei erfuhren sie den Tod des
patentierten Krokodils. Ein ganz alter Affe meldete ihn, und er
sagte »ja, ja« dazu. Das sagte er immer, und darum galt er für sehr
klug. Der kleine Makak freilich wußte mehr davon; denn er hatte ja
das verblichene Krokodil persönlich gekannt, so persönlich, daß es
ihn fast gefressen hätte. Und das ist die persönlichste
Bekanntschaft, die man machen kann. Und da die Dame d'honneur
gerade auf einen Dattelbaum geklettert war und fraß – sie fühlte
keine Liebe mehr und fraß daher doppelt –, so erzählte der
kleine Makak seiner Liebsten die ganze gräßliche Geschichte. »Laß
dich ja niemals patentieren, Makchen!« sagte die Kleine und
umschlang ihn mit ihrem Schwanz.</p>
<p class="calibre2">»Nein, niemals«, sagte Makchen und suchte liebevoll und emsig im
Fell seiner Braut.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?5aad8684